import {
  SET_ACTIVITIES,
  ADD_ACTIVITY,
  UPDATE_ACTIVITY,
  REMOVE_ACTIVITY,
} from "../constants/activities";

export const setActivities = (activities) => ({
  type: SET_ACTIVITIES,
  activities,
});

export const addActivity = (activity) => ({
  type: ADD_ACTIVITY,
  activity,
});

export const updateActivity = (activityId, updates) => ({
  type: UPDATE_ACTIVITY,
  activityId,
  updates,
});

export const removeActivity = (activityId) => ({
  type: REMOVE_ACTIVITY,
  activityId,
});
